import { Spacing, styled } from 'ui';

export const StyledButtonContent = styled('div')`
  display: flex;
  padding: ${({ theme }) => theme.spacing(Spacing.Small)};
  gap: ${({ theme }) => theme.spacing(Spacing.Small)};
  justify-content: flex-end;
  width: 100%;
`;
